<downloadable-file [displayName]="displayName" [downloader]="getDownloader()"></downloadable-file>
